import React, { FunctionComponent, useState } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CodeIcon from '../../assets/media/icons/code.svg'
import style from './enterVehicleCodeButton.css'
import EnterVehicleCodeModalWrapper from '../enter-vehicle-code-modal-wrapper'

export type Props = {
    brand: string
    vinEnabled: boolean
    vehicleCodeEnabled: boolean
}

const EnterVehicleCodeButton: FunctionComponent<Props> = (props) => {
    const { brand, vinEnabled, vehicleCodeEnabled } = props
    const modalActiveState = useState(false)
    const { t } = useTranslation()

    if (!vehicleCodeEnabled && !vinEnabled) {
        return null
    }

    const clickHandler = (): void => {
        const setModalIsActive = modalActiveState[1]

        setModalIsActive(true)
    }

    const getModalButtonLabel = () => {
        if (vinEnabled && vehicleCodeEnabled) {
            return t(`vehicleCode.${brand}.enter.modalButtonLabelWithVin`)
        }
        if (vinEnabled && !vehicleCodeEnabled) {
            return t(`vin.enter.modalButtonLabel`)
        }
        return t(`vehicleCode.${brand}.enter.modalButtonLabel`)
    }

    return (
        <>
            <button
                onClick={clickHandler}
                className={style.button}
                type="button"
                data-testid="enter-vehicle-code-button"
            >
                {getModalButtonLabel()}
                <CodeIcon className={style.icon} />
            </button>
            <EnterVehicleCodeModalWrapper activeState={modalActiveState} />
        </>
    )
}

export default EnterVehicleCodeButton
